<template>
  <div class="ma-4" ref="embed">
    <div v-if="campaign" v-show="!config.hideTitle" class="campaign-details text-center">
      <h2 class="ma-0 mb-2">{{ campaign.title }}</h2>
      <p class="ingress mb-2">{{ campaign.description }}</p>
    </div>
    <div v-else v-show="!config.hideTitle" class="campaign-details text-center">
      <h2 class="ma-0">{{ config.title }}</h2>
      <p class="ingress mb-2">{{ parsedDescription }}</p>
    </div>

    <div
      class="filter-panel pa-4 mb-8"
      style="background-color: #eeeeee"
      v-if="config.showFilterPanel"
    >

      <v-row>
        <v-col cols="12" sm="6">
          <v-row>
            <v-col><h3 class="mb-0">Search by keyword</h3></v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                label="Text search"
                v-model="filterString"
                outlined
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="6">
          <v-row>
            <v-col><h3 class="mb-0">Filter by:</h3></v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12">
              <v-combobox
                label="Industry"
                :items="getCategories"
                item-text="name"
                item-value="id"
                multiple
                v-model="filterCategories"
                outlined
                hide-details
                :return-object="false"
              ></v-combobox>
            </v-col>
            <!-- <v-col cols="12" sm="6">
              <v-combobox
                label="Area"
                :items="getCities"
                item-text="city"
                item-value="city"
                multiple
                v-model="filterCities"
                outlined
                hide-details
                :return-object="false"
              ></v-combobox>
            </v-col> -->
            <!-- <v-col cols="12" sm="4" v-if="campaign">
              <v-combobox
                label="Campaign"
                :items="getCampaigns"
                item-text="title"
                item-value="slug"
                multiple
                v-model="selectedCampaign"
                outlined
                hide-details
                @change="refreshJobs(true)"
              ></v-combobox>
            </v-col> -->
          </v-row>
        </v-col>
      </v-row>
    </div>

    <v-row
      class="mb-2"
      v-if="config.showStatistics && statistics && getCategories"
    >
      <v-col
        v-for="category in getCategories.slice(0, config.categoryElements)"
        :key="category.id"
      >
        <v-card
          elevation="0"
          class="text-center pa-4"
          outlined
          @click="openPortal(category.id)"
        >
          <label>{{ category.name }}</label>
          <big>{{
            statistics.categoryCounts.find((cat) => cat.id == category.id).count
          }}</big>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-if="loading">
      <v-col>
        <div class="ma-8 text-center">
          <v-progress-circular
            :size="50"
            color="primary"
            indeterminate
            style="margin: 0 auto"
          >
          </v-progress-circular>
        </div>
      </v-col>
    </v-row>
    <div v-if="!loading && showJobList && !config.showAllJobs">
      <h3>Latest English speaking jobs</h3>
      <div class="mb-6 animated-list">
        <v-card
          outlined
          class="job mb-2 pa-4"
          elevation="0"
          v-for="item in jobList.slice(0, config.jobElements)"
          :key="item.id"
          @mouseover="animationActive = false"
          @mouseleave="animationActive = true"
        >
          <v-row no-gutters dense>
            <v-col cols="8">
              <p class="job-title mt-0">{{ item.title }}</p>
              <p class="job-subtitle">{{ item.employer.name }}</p>
            </v-col>
            <v-col cols="4" class="text-right">
              <p class="job-title">{{ item.location.city }}</p>
              <p class="job-subtitle">{{ item.location.area }}</p>
            </v-col>
          </v-row>
        </v-card>
      </div>
      <v-btn
        color="primary"
        href="https://jobsinfinland.fi"
        block
        large
        elevation="0"
        target="_blank"
        >View all in portal</v-btn
      >
    </div>
    <div
      v-if="!loading && config.showAllJobs"
      class="job-list"
      :class="{ 'large-cards': config.largeCards }"
    >
      <v-row v-if="config.showFilters" class="mb-4 job-filters text-center">
        <v-col>
          <v-chip
            v-for="category in getCategories"
            :key="category.id"
            @click="toggleCategory(category)"
            class="ma-1 text-uppercase"
            :outlined="!filterCategories.includes(category.id)"
            color="primary"
            >{{ category.name }}</v-chip
          >
          <v-btn
            text
            rounded
            small
            color="primary"
            @click="filterCategories = []"
          >
            <v-icon small>mdi-close</v-icon>
            Reset filters
          </v-btn>
        </v-col>
      </v-row>
      <div
        class="mb-6"
        :class="{ 'grid-list': !config.largeCards }"
        v-if="showJobList"
      >
        <v-card
          :outlined="!config.largeCards"
          class="job mb-2 pa-4"
          elevation="0"
          v-for="item in jobList.slice(
            pagination.startItem,
            pagination.endItem
          )"
          :key="item.id"
          @mouseover="animationActive = false"
          @mouseleave="animationActive = true"
          @click="!config.largeCards ? openUrl(item) : null"
          :ripple="!config.largeCards"
        >
          <v-row no-gutters dense class="pb-2 job-details">
            <v-col cols="12" sm="2" v-if="config.largeCards">
              <div
                v-if="item.imageUrl"
                class="job-logo large"
                v-bind:style="{
                  'background-image': 'url(' + item.imageUrl + ')',
                }"
              ></div>
            </v-col>
            <v-col cols="12" sm="8" :class="{ 'pl-4': config.largeCards }">
              <p class="job-title mt-0">{{ item.title }}</p>
              <p class="job-subtitle job-organization">
                {{ item.employer.name }}
              </p>
              <p class="job-subtitle job-location" v-if="config.largeCards">
                <!-- {{ item.location.city ? item.location.city + ", " : ""
                }}{{ item.location.area }} -->
                {{ item.location.country }}
              </p>
              <div
                class="job-tags d-flex align-center"
                v-if="item.clustering.categories.length > 0"
              >
                <v-icon
                  small
                  color="primary"
                  class="mr-2"
                  v-if="config.largeCards"
                  >mdi-tag</v-icon
                >
                <span
                  v-for="category of item.clustering.categories"
                  :key="category.name"
                  class="job-tag mr-2"
                  >{{ category.name.toLowerCase() }}</span
                >
              </div>
              <v-btn
                class="mt-2"
                elevation="0"
                outlined
                tile
                color="primary"
                @click="openUrl(item)"
                v-if="config.largeCards"
                >Apply for this job</v-btn
              >
            </v-col>
            <v-col cols="4" class="text-right" v-if="!config.largeCards">
              <div
                v-if="item.imageUrl"
                class="job-logo"
                v-bind:style="{
                  'background-image': 'url(' + item.imageUrl + ')',
                  width: '100%',
                  height: '40px',
                  'background-position': 'top right',
                }"
              ></div>
            </v-col>
          </v-row>
          <v-row
            no-gutters
            dense
            class="mt-2 pt-2 align-center job-meta b-t"
            v-if="!config.largeCards"
          >
            <v-col>
              <p class="job-subtitle job-location">
                {{ item.location.city ? item.location.city + ", " : ""
                }}{{ item.location.area }}
              </p>
            </v-col>
          </v-row>
        </v-card>
      </div>
      <div class="mb-6" v-else-if="filterCategories.length > 0">
        No jobs in the selected categories.
      </div>
      <div class="mb-6" v-else>No jobs found.</div>
    </div>
    <div
      class="job-list-pagination mt-4 text-center mb-6"
      v-if="pageCount > 0 && config.showAllJobs"
    >
      <v-btn
        tile
        elevation="0"
        @click="prevPage()"
        :color="currentPage == 1 ? 'transparent' : 'primary'"
        :disabled="currentPage == 1"
        class="prev-btn"
        >Previous</v-btn
      >
      <v-btn
        tile
        elevation="0"
        @click="selectPage(page - 1)"
        v-for="page in pageCount < 10 ? pageCount : 10"
        :key="page"
        :color="currentPage == page ? 'gray' : 'transparent'"
        class="page-btn"
        >{{ page }}</v-btn
      >
      <v-btn
        tile
        elevation="0"
        @click="nextPage()"
        :color="currentPage == pageCount ? 'transparent' : 'primary'"
        :disabled="currentPage == pageCount"
        class="next-btn"
        >Next</v-btn
      >
    </div>
    <div
      class="job-list-view-all mt-4 text-center mb-6"
      v-if="pageCount > 0 && config.showAllJobs"
    >
      <a href="https://jobsinfinland.fi" target="_blank">View all jobs</a>
    </div>
    <div
      class="submit-banner"
      @click="openUrl('/for-employers?showSubmit=1')"
      v-if="config.showSubmit"
    >
      <h3>
        Want to see your company’s job openings here? Contact Business Finland.
      </h3>
    </div>
  </div>
</template>
<script>
import Cities from "@/assets/fi-cities.json";

export default {
  name: "Embed",
  data() {
    return {
      config: {
        // Which campaign to show
        campaignId: null,
        // Which categories to show
        categories: [],
        // How many categories to show
        categoryElements: 4,
        // How many jobs to show
        jobElements: 3,
        // Which areas to show
        areas: [],
        // Which cities to show
        cities: [],
        // Title text
        title: "Find you new job in Finland",
        // Description text, you can use [TOTAL_JOBS] to get sum of jobs in stats
        description:
          "There are currently [TOTAL_JOBS] English speaking jobs available throughout Finland, especially in the following categories. Browse through opportunities and take your pick through our job portal.",
        // Show user selectable category filters
        showFilters: false,
        // Show dropdown filters panel
        showFilterPanel: false,
        // Show all jobs as a list, disable animation
        showAllJobs: false,
        // URL to external stylesheet, should override existing styling
        externalStyle: null,
        // Show direct links to jobs in cards
        directLinks: false,
        // Show submit button for new jobs
        showSubmit: true,
        // Show statistics cards
        showStatistics: true,
        // Hide title and description fields
        hideTitle: false,
        // Large job cards
        largeCards: false,
      },
      animationActive: true,
      animationDuration: 4000,
      filterCategories: [],
      filterCities: [],
      filterString: "",
      filterCampaigns: [],
      loading: false,
      campaign: null,
      pagination: {
        startItem: 0,
        endItem: 12,
        perPage: 12,
      },
    };
  },
  mounted() {
    let q = this.$route.query;

    this.config.jobElements = q.jobcount ? q.jobcount : this.config.jobElements;
    this.config.categories = q.categories
      ? q.categories.split(",")
      : this.config.categories;
    this.config.categoryElements = q.categorycount
      ? q.categorycount
      : this.config.categoryElements;
    this.config.campaignId = q.campaignId
      ? q.campaignId
      : this.config.campaignId;
    this.config.title = q.title ? q.title : this.config.title;
    this.config.description = q.description
      ? q.description
      : this.config.description;

    // New configs
    this.config.showFilters =
      typeof q.showFilters !== undefined
        ? q.showFilters == true
        : this.config.showFilters;
    this.config.showFilterPanel =
      typeof q.showFilterPanel !== undefined
        ? q.showFilterPanel == true
        : this.config.showFilterPanel;
    this.config.showAllJobs =
      typeof q.showAllJobs !== undefined
        ? q.showAllJobs == true
        : this.config.showAllJobs;
    this.config.externalStyle =
      typeof q.externalStyle !== undefined
        ? q.externalStyle
        : this.config.externalStyle;
    this.config.directLinks =
      typeof q.directLinks !== undefined
        ? q.directLinks == true
        : this.config.directLinks;
    this.config.showSubmit =
      typeof q.showSubmit !== undefined
        ? q.showSubmit == true
        : this.config.showSubmit;
    this.config.showStatistics =
      typeof q.showStatistics !== undefined
        ? q.showStatistics == true
        : this.config.showStatistics;
    this.config.hideTitle =
      typeof q.hideTitle !== undefined
        ? q.hideTitle == true
        : this.config.hideTitle;
    this.config.largeCards =
      typeof q.largeCards !== undefined
        ? q.largeCards == true
        : this.config.largeCards;

    this.config.areas = q.areas ? q.areas.split(",") : this.config.areas;
    this.config.cities = q.cities ? q.cities.split(",") : this.config.cities;

    // Start emitting height to parent
    setInterval(
      function () {
        if (this.$refs.embed !== undefined) {
          let el = this.$refs.embed;
          let height = el.offsetHeight + 2 * 16;
          window.parent.postMessage({ height: height }, "*");
        }
      }.bind(this),
      500
    );

    // Check if user has provided custom stylesheet
    if (this.config.externalStyle) {
      this.injectExternalStyle();
    }

    // Set active campaign
    if (this.config.campaignId) {
      this.filterCampaigns = [this.config.campaignId];
    }

    // Start fetching embed details
    this.refreshJobs();

    this.$store.dispatch("dispatchGetStatistics", { campaignId: null });
    this.$store.dispatch("dispatchCategoriesWithDetails");
  },
  methods: {
    refreshJobs(fromFilter) {
      // Check if user has provided campaignId
      if (fromFilter && this.filterCampaigns.length > 0) {
        this.fetchCampaign();
      } else if (fromFilter) {
        this.fetchJobs();
      } else if (this.config.campaignId) {
        this.fetchCampaign();
      } else {
        this.fetchJobs();
      }
    },
    fetchCampaign() {
      this.loading = true;
      // Get campaign content
      this.$store
        .dispatch("dispatchGetCampaign", { campaignId: this.config.campaignId })
        .then(() => {
          this.campaign = this.$store.state.campaign;
        });
      this.$store
        .dispatch("dispatchGetCampaignJobs", {
          campaignId: this.config.campaignId,
        })
        .then(() => {
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
          console.error("Problem loading jobs.");
        });
    },
    fetchJobs() {
      this.loading = true;
      this.$store
        .dispatch("dispatchGetJobs")
        .then(() => {
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
          console.error("Problem loading jobs.");
        });
    },
    openPortal(category) {
      let url = window.location;
      window.open(
        url.protocol + "//" + url.host + "/?keyword=" + category,
        "_parent"
      );
    },
    toggleCategory(category) {
      if (this.filterCategories.includes(category.id)) {
        this.filterCategories = this.filterCategories.filter(
          (c) => c != category.id
        );
      } else {
        this.filterCategories.push(category.id);
      }
    },
    openUrl(item) {
      if (typeof item !== "object") {
        window.open(item);
      } else {
        window.open(item.externalUrl);
      }
    },
    injectExternalStyle() {
      // Inject custom style file into DOM hierarchy
      let link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = this.config.externalStyle;
      document.head.appendChild(link);
    },
    nextPage() {
      this.pagination.startItem += this.pagination.perPage;
      this.pagination.endItem += this.pagination.perPage;
    },
    prevPage() {
      this.pagination.startItem -= this.pagination.perPage;
      this.pagination.endItem -= this.pagination.perPage;
    },
    selectPage(page) {
      this.pagination.startItem = page * this.pagination.perPage;
      this.pagination.endItem =
        this.pagination.startItem + this.pagination.perPage;
    },
  },
  computed: {
    selectedCampaign: {
      get() {
        return this.filterCampaigns.length > 0 ? [this.campaign] : [];
      },
      set(value) {
        this.filterCampaigns = value.length > 0 ? [value] : [];
      },
    },
    statistics() {
      let statistics = this.$store.state.statistics;
      return statistics !== null ? statistics : [];
    },
    jobList() {
      let list =
        this.config.campaignId && this.filterCampaigns.length > 0
          ? this.$store.state.campaignJobs
          : this.$store.state.jobs;

      if (!list) return [];

      if (!this.config.showAllJobs) {
        // Randomize list order every x seconds
        setInterval(() => {
          if (list !== null && this.animationActive) {
            list = list.sort(() => Math.random() - 0.5).slice(0, 3);
          }
        }, this.animationDuration);
      }

      // Filter by categories query param
      if (this.config.categories.length > 0) {
        list = list.filter((job) => {
          return job.clustering.categories.find((cat) => {
            return this.config.categories.includes(cat.id);
          });
        });
      }

      // Filter by user selected categories
      if (this.filterCategories.length > 0) {
        list = list.filter((job) => {
          return job.clustering.categories.find((cat) => {
            return this.filterCategories.includes(cat.id);
          });
        });
      }

      // Filter by user selected cities
      if (this.filterCities.length > 0) {
        list = list.filter((job) => {
          return this.filterCities.includes(job.location.city);
        });
      }

      // Filter by user search string
      if (this.filterString.length > 0) {
        list = list.filter((job) => {
          return job.title.toLowerCase().includes(this.filterString.toLowerCase()) || 
            job.employer.name.toLowerCase().includes(this.filterString.toLowerCase());
        });
      }

      // Filter by areas query param
      if (this.config.areas.length > 0) {
        list = list.filter((job) => {
          return this.config.areas.includes(
            job.location.area.toLowerCase().replace(" ", "-")
          );
        });
      }

      // Filter by city query param
      if (this.config.cities.length > 0) {
        list = list.filter((job) => {
          return this.config.cities.includes(
            job.location.city.toLowerCase().replace(" ", "-")
          );
        });
      }

      return list;
    },
    showJobList() {
      return this.jobList !== null && this.jobList.length > 0;
    },
    getCategories() {
      let categories = this.$store.state.categoriesWithDetails;
      let catFilter = [];
      if (this.config.categories.length > 0) {
        catFilter = this.config.categories;
      } else {
        catFilter = this.getStatCategories;
      }
      return categories !== null
        ? this.$store.state.categoriesWithDetails.filter((category) => {
            return catFilter.includes(category.id);
          })
        : [];
    },
    getCities() {
      return Cities;
    },
    getCampaigns() {
      // TODO: Fetch list of campaigns from BE
      return this.campaign ? [this.campaign] : [];
    },
    getStatCategories() {
      let categoryCounts = this.statistics.categoryCounts
        ? this.statistics.categoryCounts
        : [];
      return categoryCounts.length > 0
        ? categoryCounts.map((stat) => stat.id)
        : [];
    },
    totalJobs() {
      let count = 0;
      if (this.statistics !== null) {
        /* let keys = Object.keys(this.statistics)
                        .filter((key) => {
                            return this.config.categories.includes(key)
                        });
            for(let key of keys){
                count += this.statistics[key];
            } */
        count = this.statistics.totalCount;
      }
      return count;
    },
    parsedDescription() {
      return this.config.description.replace("[TOTAL_JOBS]", this.totalJobs);
    },
    pageCount() {
      return Math.floor(this.jobList.length / this.pagination.perPage);
    },
    currentPage() {
      return Math.floor(this.pagination.endItem / this.pagination.perPage);
    },
  },
};
</script>
<style scoped>
h2{
  font-size: 38px;
}
h2,
h3 {
  text-transform: uppercase;
}
h3 {
  color: #000;
}
.ingress {
  font-size: 1em;
}
big {
  font-size: 3em;
}
.job-title {
  font-size: 1.1em;
  line-height: 1.2em;
  font-weight: 400;
  margin-top: 0.7em;
}
.large-cards .job-title {
  font-weight: 600;
  font-size: 1.2em;
  margin-bottom: 0.2em;
}
.job-subtitle {
  font-size: 1em;
  opacity: 0.7;
  margin-bottom: 0;
}
.large-cards .job-organization {
  font-size: 1.1em;
}
.large-cards .job-location {
  font-size: 0.9em;
}
.job-tag {
  font-size: 0.8em;
  color: rgba(0, 45, 160, 1);
  text-transform: uppercase;
}
.large-cards .job-tag {
  font-size: 0.9em;
}
.job-tag::after {
  content: ", ";
}
.job-tag:last-child::after {
  content: "";
}
.job-logo {
  width: 110px;
  height: 72px;
  background-color: transparent;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}
.job-logo.large {
  width: 100%;
  height: 130px;
  margin-bottom: 1em;
}
.job p {
  margin: 0;
}
.animated-list .v-card p,
.grid-list .v-card {
  animation: fadeIn 500ms ease-in;
}
.grid-list {
  display: flex;
  flex-wrap: wrap;
  margin: -0.5em;
}

.grid-list .v-card {
  flex: 1;
  margin: 0.5em;
  min-width: 300px;
  max-width: 600px;
}

.job-list-pagination {
  margin: auto;
}

.submit-banner {
  text-align: center;
  cursor: pointer;
}

.submit-banner h3 {
  color: rgba(0, 45, 160, 1);
}

@keyframes fadeIn {
  0% {
    opacity: 0;
    color: rgba(0, 45, 160, 1);
  }
  100% {
    opacity: 1;
    color: inherit;
  }
}
</style>